import { useTranslation } from 'react-i18next'

import { GrowthCategory } from '@mc/api'
import { Button, ResponsiveHandler } from '@mc/design-system'

import { useTwoPageQRExperiment } from '../../hooks'

import styles from './CatButton.module.scss'

interface CatButtonProps {
  category: GrowthCategory
  onClick: (cat: GrowthCategory) => void
  selectedCategory?: string
  control: React.ReactNode
}

export const CatButton = ({
  category,
  selectedCategory,
  onClick,
  control,
}: CatButtonProps) => {
  const { t } = useTranslation('@mc/next')
  const { isEnabled } = useTwoPageQRExperiment()

  if (!isEnabled) return control

  return (
    <ResponsiveHandler>
      {({ isXS }) => (
        <Button
          className={`mc-mr-2 mc-px-4 ${styles.title}`}
          key={category.slug as string}
          kind={selectedCategory === category.slug ? 'secondary' : 'tertiary'}
          size={isXS ? 'sm' : 'md'}
          onClick={() => onClick(category)}
        >
          {category.name}
          <span className='mc-sr-only'>
            {t('categories.a11y.category')}
            {selectedCategory === category.slug &&
              t('categories.a11y.selected')}
          </span>
        </Button>
      )}
    </ResponsiveHandler>
  )
}
